<div class="is-dynamic-form">
  <!-- Cabeçalho -->
  <div *ngIf="config.title || config.description" class="mb-4">
    <h5 *ngIf="config.title" class="fw-semibold text-dark mb-1">
      {{ config.title }}
    </h5>
    <p *ngIf="config.description" class="text-muted small mb-0">
      {{ config.description }}
    </p>
  </div>

  <!-- Formulário -->
  <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
    <div class="row">
      <ng-container *ngFor="let field of config.fields">
        <div
          *ngIf="isVisible(field)"
          [class]="getColClass(field) + ' ' + (field.cssClass || '')"
        >
          <!-- Text / Email / Tel / URL / Number / Date / Time -->
          <ng-container
            *ngIf="
              [
                'text',
                'email',
                'tel',
                'url',
                'number',
                'date',
                'datetime-local',
                'time',
              ].includes(field.type)
            "
          >
            <is-input-field
              [label]="field.label"
              [placeholder]="field.placeholder || ''"
              [type]="field.type"
              [prefixIcon]="field.prefixIcon || ''"
              [helpText]="field.helpText || ''"
              [required]="!!field.validation?.required"
              [readonly]="!!field.readonly"
              [control]="form.get(field.key)"
              [formControlName]="field.key"
            ></is-input-field>
          </ng-container>

          <!-- Password -->
          <ng-container *ngIf="field.type === 'password'">
            <is-password-field
              [label]="field.label"
              [placeholder]="field.placeholder || ''"
              [prefixIcon]="field.prefixIcon || 'bx-lock-alt'"
              [helpText]="field.helpText || ''"
              [required]="!!field.validation?.required"
              [control]="form.get(field.key)"
              [formControlName]="field.key"
            ></is-password-field>
          </ng-container>

          <!-- Datepicker (flatpickr) -->
          <ng-container *ngIf="field.type === 'datepicker'">
            <is-datepicker-field
              [label]="field.label"
              [placeholder]="field.placeholder || 'dd/mm/aaaa'"
              [required]="!!field.validation?.required"
              [helpText]="field.helpText || ''"
              [mode]="field.datepickerMode || 'single'"
              [minDate]="field.minDate || ''"
              [maxDate]="field.maxDate || ''"
              [control]="form.get(field.key)"
              [formControlName]="field.key"
            ></is-datepicker-field>
          </ng-container>

          <!-- Currency -->
          <ng-container *ngIf="field.type === 'currency'">
            <is-currency-field
              [label]="field.label"
              [placeholder]="field.placeholder || '0,00'"
              [prefix]="field.currencyPrefix || 'R$'"
              [required]="!!field.validation?.required"
              [helpText]="field.helpText || ''"
              [control]="form.get(field.key)"
              [formControlName]="field.key"
            ></is-currency-field>
          </ng-container>

          <!-- Mask -->
          <ng-container *ngIf="field.type === 'mask'">
            <is-mask-field
              [label]="field.label"
              [placeholder]="field.placeholder || ''"
              [mask]="field.mask || ''"
              [prefixIcon]="field.prefixIcon || ''"
              [required]="!!field.validation?.required"
              [helpText]="field.helpText || ''"
              [control]="form.get(field.key)"
              [formControlName]="field.key"
            ></is-mask-field>
          </ng-container>

          <!-- File -->
          <ng-container *ngIf="field.type === 'file'">
            <is-file-field
              [label]="field.label"
              [accept]="field.accept || ''"
              [required]="!!field.validation?.required"
              [helpText]="field.helpText || ''"
              [maxSizeMb]="field.maxSizeMb || 10"
              [control]="form.get(field.key)"
              [formControlName]="field.key"
            ></is-file-field>
          </ng-container>

          <!-- Multi-file -->
          <ng-container *ngIf="field.type === 'multi-file'">
            <is-multi-file-field
              [label]="field.label"
              [accept]="field.accept || ''"
              [required]="!!field.validation?.required"
              [helpText]="field.helpText || ''"
              [maxSizeMb]="field.maxSizeMb || 10"
              [maxFiles]="field.maxFiles || 10"
              [control]="form.get(field.key)"
              [formControlName]="field.key"
            ></is-multi-file-field>
          </ng-container>

          <!-- Color -->
          <ng-container *ngIf="field.type === 'color'">
            <is-color-field
              [label]="field.label"
              [required]="!!field.validation?.required"
              [helpText]="field.helpText || ''"
              [control]="form.get(field.key)"
              [formControlName]="field.key"
            ></is-color-field>
          </ng-container>

          <!-- Textarea -->
          <ng-container *ngIf="field.type === 'textarea'">
            <is-textarea-field
              [label]="field.label"
              [placeholder]="field.placeholder || ''"
              [helpText]="field.helpText || ''"
              [required]="!!field.validation?.required"
              [readonly]="!!field.readonly"
              [rows]="field.rows || 3"
              [control]="form.get(field.key)"
              [formControlName]="field.key"
            ></is-textarea-field>
          </ng-container>

          <!-- Select -->
          <ng-container *ngIf="field.type === 'select'">
            <is-select-field
              [label]="field.label"
              [placeholder]="field.placeholder || ''"
              [options]="field.options || []"
              [helpText]="field.helpText || ''"
              [required]="!!field.validation?.required"
              [control]="form.get(field.key)"
              [formControlName]="field.key"
            ></is-select-field>
          </ng-container>

          <!-- Multi-Select -->
          <ng-container *ngIf="field.type === 'multi-select'">
            <is-multi-select-field
              [label]="field.label"
              [placeholder]="field.placeholder || ''"
              [options]="field.options || []"
              [helpText]="field.helpText || ''"
              [required]="!!field.validation?.required"
              [maxItems]="field.maxItems || 0"
              [control]="form.get(field.key)"
              [formControlName]="field.key"
            ></is-multi-select-field>
          </ng-container>

          <!-- Radio -->
          <ng-container *ngIf="field.type === 'radio'">
            <is-radio-field
              [label]="field.label"
              [options]="field.options || []"
              [control]="form.get(field.key)"
              [formControlName]="field.key"
            ></is-radio-field>
          </ng-container>

          <!-- Checkbox / Switch -->
          <ng-container
            *ngIf="field.type === 'checkbox' || field.type === 'switch'"
          >
            <is-checkbox-field
              [label]="field.label"
              [control]="form.get(field.key)"
              [formControlName]="field.key"
            ></is-checkbox-field>
          </ng-container>

          <!-- Hidden -->
          <ng-container *ngIf="field.type === 'hidden'">
            <input type="hidden" [formControlName]="field.key" />
          </ng-container>
        </div>
      </ng-container>
    </div>

    <!-- Ações -->
    <div class="d-flex align-items-center justify-content-between mt-4 pt-2">
      <!-- Esquerda: Salvar + Limpar -->
      <div class="d-flex align-items-center gap-2">
        <is-button
          type="submit"
          variant="primary"
          [loading]="loading"
          [disabled]="loading"
          [icon]="config.submitIcon || 'bx-check'"
        >
          {{ config.submitLabel || ("IS_LIB.SAVE" | translate) }}
        </is-button>

        <is-button
          *ngIf="config.showReset"
          type="button"
          variant="outline-secondary"
          icon="bxs-eraser"
          (clicked)="reset()"
        >
          {{ config.resetLabel || ("IS_LIB.CLEAR" | translate) }}
        </is-button>
      </div>

      <!-- Direita: Cancelar (vermelho) -->
      <is-button
        *ngIf="config.showCancel"
        type="button"
        variant="outline-danger"
        icon="bx-x"
        (clicked)="onCancel()"
      >
        {{ config.cancelLabel || ("IS_LIB.CANCEL" | translate) }}
      </is-button>
    </div>
  </form>
</div>
